import React from 'react'

import { HiPencil, HiTrash } from 'react-icons/hi2'
import { twMerge } from 'tailwind-merge'

import IconButton from '@/components/common/IconButtonV2'
import { Toolbar } from '@/components/common/TextArea/RichTextArea/menus/components/Toolbar'

export type LinkPreviewPanelProps = {
  url: string
  className?: string
  onEdit: () => void
  onClear: () => void
}

export const LinkPreviewPanel: React.FC<LinkPreviewPanelProps> = ({
  url,
  className,
  onClear,
  onEdit,
}) => {
  return (
    <div className={twMerge('flex items-center gap-1', className)}>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm underline break-all text-blue-600 dark:text-blue-400 hover:underline"
      >
        {url}
      </a>
      <Toolbar.Divider />
      <IconButton
        onClick={onEdit}
        aria-label="Edit link"
        title="Edit link"
        tooltip="Edit link"
      >
        <HiPencil className="w-4 h-4 text-primary-600 dark:text-primary-400" />
      </IconButton>
      <IconButton
        onClick={onClear}
        aria-label="Remove link"
        title="Remove link"
        tooltip="Remove link"
      >
        <HiTrash className="w-4 h-4 text-red-600 dark:text-red-500" />
      </IconButton>
    </div>
  )
}
